import useTranslator from "../../../hooks/useTranslator";
import { Modal } from "react-bootstrap";

const CreditDeductionPopup = (props) => {
  const { openModal, setOpenModal, openReport, totalProfiles } = props;
  const { _t } = useTranslator();

  const PER_PROFILE_COST = 5;
  const onClose = () => {
    setOpenModal(false);
  };

  return (
    openModal && (
      <Modal
        show={openModal}
        onHide={onClose}
        centered
        className="newmodalui max-w-lg tailwind-base-modal wrapper-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_t(
              "confirmCreditUsage",
              "Title for popup for self serving tool when LL tries to open a profile and deduction is needed."
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <p className="text-center">
              {_t(
                "youreAboutToGenerateaReportThatIncludesProfilesYouHaventViewedYet",
                "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
              )}{" "}
            </p>
            <p className="text-center">
              {_t(
                "thisActionWillConsume",
                "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
              )}{" "}
              <span className="fw-bold text-decoration-underline">
                {totalProfiles * PER_PROFILE_COST} {_t("credits")}
              </span>
            </p>
            <p className="text-center">
              {_t(
                "doYouWantToContinue",
                "Description for popup for self serving tool when LL tries to open a profile and deduction is needed."
              )}
            </p>
          </>
        </Modal.Body>
        <div className="inviteButtonWrapper">
          <button
            type="button"
            onClick={onClose}
            className="btnNext btnnextpre mr-2"
          >
            {_t("goBack")}
          </button>
          <button
            type="button"
            onClick={openReport}
            className="btnNext basicInfoButton greenHover"
          >
            {_t("confirm")}
          </button>
        </div>
      </Modal>
    )
  );
};

export default CreditDeductionPopup;
